import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { PaymentData, PaymentRequest, PaymentResponse, PaymentResultRequest } from '../types';

// Kreiranje axios instance
const apiClient: AxiosInstance = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: false
});

export const paymentService = {
  async getPaymentInfo(token: string | null): Promise<PaymentData> {
    try {     
      const response: AxiosResponse<PaymentData> = await apiClient.get('/payment/info', {
        params: { token }
      });

      return response.data;
    } catch (error) {
      console.error('GREŠKA u getPaymentInfo:', error);
      throw error;
    }
  },

  async preparePayment(paymentRequest: PaymentRequest): Promise<PaymentResponse> {
    try {     
      const response: AxiosResponse<PaymentResponse> = await apiClient.post('/payment/prepare-payment', paymentRequest);
    
      return response.data;
    } catch (error) {
      console.error('GREŠKA u preparePayment:', error);
      throw error;
    }
  },

  async successPayment(successRequest: PaymentResultRequest): Promise<void> {
    try {     
      await apiClient.post('/payment/success', successRequest);
    } catch (error) {
      console.error('GREŠKA u successPayment:', error);
      throw error;
    }
  },

  async cancelPayment(cancelRequest: PaymentResultRequest): Promise<void> {
    try {     
      await apiClient.post('/payment/cancel', cancelRequest);
    } catch (error) {
      console.error('GREŠKA u cancelPayment:', error);
      throw error;
    }
  }
};
